<template>
    <q-table
        :rows="assets"
        :columns="columns"
        virtual-scroll
        row-key="index"
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
        :virtual-scroll-sticky-size-start="48"
        class="sticky-table"
        :hide-bottom="assets.length > 0"
        :no-data-label="$t('No linked assets')"
    >
        <template v-slot:body-cell-name="props">
            <q-td :props="props">
                <div class="text-left row items-center justify-between">
                    {{ props.row.name }}
                    <!-- Go to Asset Dashboard -->
                    <q-btn
                        flat
                        dense
                        icon="open_in_new"
                        color="grey"
                        :disabled="!hasAccessToAsset(props.row.id)"
                        @click="
                            $router.push({
                                name: 'asset_dashboard',
                                params: {
                                    facilityId: facilityId,
                                    assetId: props.row.id
                                }
                            })
                        "
                    >
                        <q-tooltip>{{
                            getTooltipText(props.row.id)
                        }}</q-tooltip>
                    </q-btn>
                </div>
            </q-td>
        </template>
    </q-table>
</template>

<script>
import { mapState } from 'pinia';
import { useAuthStore } from '@stores/auth';

export default {
    name: 'DeviceLinkedAssetsTable',
    props: {
        facilityId: {
            type: [Number, String],
            required: true
        },
        assets: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            pagination: {
                rowsPerPage: 0
            },
            columns: [
                {
                    name: 'name',
                    label: this.$t('Name'),
                    field: 'name',
                    align: 'left',
                    sortable: true
                }
            ]
        };
    },
    computed: {
        ...mapState(useAuthStore, ['getUserAccess'])
    },
    methods: {
        /**
         * Check if the user has access to the asset.
         * @param {Number} assetId
         * @returns {Boolean}
         */
        hasAccessToAsset(assetId) {
            const allowedAssets = this.getUserAccess;
            return allowedAssets.some(allowed => allowed.asset === assetId);
        },
        /**
         * Get the tooltip text for the button according
         * to the user's access to the asset.
         * @param {Number} assetId
         * @returns {String}
         */
        getTooltipText(assetId) {
            return this.hasAccessToAsset(assetId)
                ? this.$t('Go to Asset')
                : this.$t('You do not have access to this asset');
        }
    }
};
</script>
